'use strict';

export default class Navigation {
  constructor() {

    //highlight primary nav when on child page
    $('.navigation__list-item--secondary.-selected').parents('.navigation__list-item--primary').addClass('-selected');

    var getClosest = function (elem, selector) {

      // Element.matches() polyfill
      if (!Element.prototype.matches) {
        Element.prototype.matches =
          Element.prototype.matchesSelector ||
          Element.prototype.mozMatchesSelector ||
          Element.prototype.msMatchesSelector ||
          Element.prototype.oMatchesSelector ||
          Element.prototype.webkitMatchesSelector ||
          function (s) {
            var matches = (this.document || this.ownerDocument).querySelectorAll(s),
              i = matches.length;
            while (--i >= 0 && matches.item(i) !== this) { }
            return i > -1;
          };
      }

      // Get the closest matching element
      for (; elem && elem !== document; elem = elem.parentNode) {
        if (elem.matches(selector)) return elem;
      }
      return null;

    };

    var loginButton = document.getElementsByClassName("login__btn");
    var primaryMenu = document.querySelectorAll(".navigation__list-item--primary");
    var primaryMenuLink = document.querySelectorAll(".navigation__list-item--primary a");
    var secondaryMenu = document.querySelectorAll(".navigation__list-item--secondary");
    var tertiaryMenu = document.querySelectorAll(".navigation__list-item--tertiary");
    var quaternaryMenu = document.querySelectorAll(".navigation__list-item--quaternary");

    // if (tertiaryMenu.length > 0) {
    //   for (var i = 0; i < secondaryMenu.length; i++) {
    //     var elem = tertiaryMenu[i];
    //     var parentWithSecondChildren = getClosest(elem, '.navigation__list-item--secondary');
    //     parentWithSecondChildren.classList.add('-has-items');
    //     parentWithSecondChildren.querySelector('a').setAttribute('aria-haspopup', 'true');
    //   }
    // }

    if (quaternaryMenu.length > 0) {
      for (var i = 0; i < quaternaryMenu.length; i++) {
        var elem = quaternaryMenu[i];
        var parentWithSecondChildren = getClosest(elem, '.navigation__list-item--tertiary');

        if (parentWithSecondChildren) {
          parentWithSecondChildren.classList.add('-has-items');
          parentWithSecondChildren.querySelector('a').setAttribute('aria-haspopup', 'true');
        }
      }
    }

    if (tertiaryMenu.length > 0) {
      for (var i = 0; i < tertiaryMenu.length; i++) {
        var elem = tertiaryMenu[i];
        var parentWithSecondChildren = getClosest(elem, '.navigation__list-item--secondary');

        if (parentWithSecondChildren) {
          parentWithSecondChildren.classList.add('-has-items');
          parentWithSecondChildren.querySelector('a').setAttribute('aria-haspopup', 'true');
        }

        elem.addEventListener('click', function (event) {
          event.stopPropagation();
          if ($(window).width() > 990) {
            var parent = getClosest(event.target, '.navigation__list-item--tertiary');
            parent.classList.toggle('-show');
          } else {
            var parent = getClosest(event.target, '.navigation__list-item--tertiary');
            parent.classList.toggle('-show');
          }
        });
      }
    }

    if (secondaryMenu.length > 0) {
      for (var i = 0; i < secondaryMenu.length; i++) {
        var elem = secondaryMenu[i];
        var parentWithChildren = getClosest(elem, '.navigation__list-item--primary');
        parentWithChildren.classList.add('-has-items');
        parentWithChildren.querySelector('a').setAttribute('aria-haspopup', 'true');

        secondaryMenu[i].querySelector('a').addEventListener('keydown', function (event) {
          var e = event.which || event.keyCode;
          var parent = getClosest(event.target, '.navigation__list-item--secondary');
          if (e === 40) {
            event.preventDefault();
            if (parent.nextElementSibling) {
              parent.nextElementSibling.querySelector('a').focus();
            }
          } else if (e === 38) {
            event.preventDefault();
            if (parent.previousElementSibling) {
              parent.previousElementSibling.querySelector('a').focus();
            }
          } else if (event.shiftKey && e == 9) {
            var parentPrimary = getClosest(this, '.navigation__list-item--primary');
            if (parentPrimary.previousElementSibling) {
              event.preventDefault();

              parentPrimary.previousElementSibling.querySelector('a').focus();

            }
          } else if (e === 9) {
            var parentPrimary = getClosest(this, '.navigation__list-item--primary');
            if (parentPrimary.nextElementSibling) {
              event.preventDefault();

              parentPrimary.nextElementSibling.querySelector('a').focus();

            } else {
              event.preventDefault();
              if (document.querySelector('.header__end button')) {
                document.querySelector('.header__end button').focus();
              }

            }

          }
        })


        elem.addEventListener('click', function (event) {
          event.stopPropagation();
          if ($(window).width() > 990) {
            var parent = getClosest(event.target, '.navigation__list-item--secondary');
            parent.classList.toggle('-show');
          } else {
            var parent = getClosest(event.target, '.navigation__list-item--secondary');
            parent.classList.toggle('-show');
          }
        });
      }
    }

    if (primaryMenuLink.length > 0) {
      for (var i = 0; i < primaryMenuLink.length; i++) {
        var elem = primaryMenuLink[i];
        elem.addEventListener('focus', function (event) {
          var parent = getClosest(event.target, '.navigation__list-item--primary');
          parent.classList.add('-show');
          parent.querySelector('a').setAttribute("aria-expanded", "true")
        });
        elem.addEventListener('blur', function (event) {
          var parent = getClosest(event.target, '.navigation__list-item--primary');
          parent.classList.remove('-show');
          parent.querySelector('a').setAttribute("aria-expanded", "false")
        });
      }
    }


    if (primaryMenu.length > 0) {
      for (var i = 0; i < primaryMenu.length; i++) {

        var elem = primaryMenu[i];

        elem.addEventListener('mouseover', function (event) {
          if ($(window).width() > 990) {
            var parent = getClosest(event.target, '.navigation__list-item--primary');
            parent.classList.add('-show');
          }

        });

        elem.addEventListener('click', function (event) {
          if ($(window).width() > 990) {
            var parent = getClosest(event.target, '.navigation__list-item--primary');
            parent.classList.toggle('-show');
          } else {
            var parent = getClosest(event.target, '.navigation__list-item--primary');
            parent.classList.toggle('-show');
          }
        });

        elem.addEventListener('focus', function (event) {
          if ($(window).width() > 990) {
            var parent = getClosest(event.target, '.navigation__list-item--primary');
            parent.classList.add('-show');
          }
        });

        primaryMenu[i].addEventListener('keydown', function (event) {
          if (this.querySelector('a') !== event.target) return;

          var e = event.which || event.keyCode;
          var parent = getClosest(event.target, '.navigation__list-item--primary');
          var secondaryLink = parent.querySelector('.navigation__list--secondary > li:first-child > a');

          if (e === 40) {
            event.preventDefault();
            secondaryLink.focus();
          } else if (e === 38) {
            event.preventDefault();
          } else if (event.shiftKey && e == 9) {
            var parentPrimary = getClosest(this, '.navigation__list-item--primary');
            if (parentPrimary.previousElementSibling) {
              event.preventDefault();
              parentPrimary.previousElementSibling.querySelector('a').focus();

            }
          } else if (e === 9) {
            var parentPrimary = getClosest(this, '.navigation__list-item--primary');

            if (parentPrimary.nextElementSibling) {
              event.preventDefault();
              parentPrimary.nextElementSibling.querySelector('a').focus();

            } else {
              event.preventDefault();
              if (document.querySelector('.header__end button')) {
                document.querySelector('.header__end button').focus();
              }
            }

          }
        })


        elem.addEventListener('mouseleave', function (event) {
          if ($(window).width() > 990) {
            var parent = getClosest(event.target, '.navigation__list-item--primary');
            parent.classList.remove('-show');
          }
        });

        elem.addEventListener('blur', function (event) {
          if ($(window).width() > 990) {
            var parent = getClosest(event.target, '.navigation__list-item--primary');
            parent.classList.remove('-show');

          }
        });

      }
    }

    var $primaryLink = $('.navigation__list-item--primary.-has-items');

    var isTouchCapable = 'ontouchstart' in window ||
      window.DocumentTouch && document instanceof window.DocumentTouch ||
      navigator.maxTouchPoints > 0 ||
      window.navigator.msMaxTouchPoints > 0;

    var primaryLinkClicked = false;

    if (isTouchCapable && $(window).width() > 990) {
      $primaryLink.on('click', function (e) {
        if (primaryLinkClicked && !$(this).hasClass('navigate')) {
          $primaryLink.removeClass("navigate");
        }
        if (!$(this).hasClass('navigate')) {
          e.preventDefault();
          $(this).addClass("navigate");
          $(this).addClass('-show');
        } else {
          primaryLinkClicked = false;
        }
        primaryLinkClicked = true;
      })
    }
  }
}
